var _defs, _text, _text2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 366.89 279.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:28px;fill:#812990;font-family:ProximaNova-Black, Proxima Nova;font-weight:800;}.cls-2{font-size:22px;fill:#6b7b84;font-family:ProximaNova-Regular, Proxima Nova;}.cls-3{letter-spacing:-0.13em;}.cls-4{letter-spacing:-0.06em;}.cls-5{letter-spacing:-0.03em;}.cls-6{letter-spacing:-0.04em;}.cls-7{letter-spacing:-0.02em;}.cls-8{fill:none;stroke:#f04e23;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.66px;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(30.27 134.03)"
  }, "Congrats, Smart One! ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(85.25 167.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.98,
    y: 0
  }, "ou've mastered the "), /*#__PURE__*/React.createElement("tspan", {
    x: -21.79,
    y: 26.4
  }, "Brand.Identity"), /*#__PURE__*/React.createElement("tspan", {
    x: 110.65,
    y: 26.4
  }, ".Guidelines"), /*#__PURE__*/React.createElement("tspan", {
    x: -70.39,
    y: 52.8
  }, "now it"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: -12.4,
    y: 52.8
  }, "\u2019"), /*#__PURE__*/React.createElement("tspan", {
    x: -8,
    y: 52.8
  }, "s your turn to create designs"), /*#__PURE__*/React.createElement("tspan", {
    x: -76.1,
    y: 79.2
  }, "as smart and sharp as KEFEVS itself"), /*#__PURE__*/React.createElement("tspan", {
    x: 267.41,
    y: 79.2
  }, ". "), /*#__PURE__*/React.createElement("tspan", {
    x: -11.35,
    y: 105.6
  }, "Go Ahead, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 96.64,
    y: 105.6
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 109.16,
    y: 105.6
  }, "tart Smart!"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M156.8,19.22l.87-4.56a8.73,8.73,0,0,1,1-2.75l4.95-8.37a4.48,4.48,0,0,1,5.88-1.73h0a4.48,4.48,0,0,1,2.1,5.8l-4,9.31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M157.1,42.71l-2.29-8.66a8.8,8.8,0,0,1-.13-3.82l.95-4.95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M162.45,89.36V81.58a59.2,59.2,0,0,0-1-10.63l-4.36-23.82a12.5,12.5,0,0,1,.23-5.54l4.56-16.76a8.87,8.87,0,0,1,1.87-3.5L174.55,8.88a9,9,0,0,1,2.37-1.94l8.91-5a4.52,4.52,0,0,1,6,1.46l.06.09a4.66,4.66,0,0,1-1.11,6.33L182,16.28l-6.67,9a5.34,5.34,0,0,0-1.05,3.18v9.46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M206.47,62.67a30.18,30.18,0,0,1-6.6,8.11l-7.45,6.45a20.08,20.08,0,0,0-6.71,12.13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M164.57,44.81h0a19.82,19.82,0,0,0,9.6-6.75l6.73-8.71a5.31,5.31,0,0,1,4.57-2.06l23.32,1.62a2.14,2.14,0,0,1,2,2.12h0a6.24,6.24,0,0,1-6.24,6.25h-17l-3.78,6.81a9.9,9.9,0,0,0,.31,10.12h0a8.47,8.47,0,0,0,7.11,3.89h0A8.44,8.44,0,0,0,197.71,55L203,48.53V43.31A7.27,7.27,0,0,1,210.23,36h0a2.14,2.14,0,0,1,2.13,2.13v12.1a7,7,0,0,1-.9,3.44l-1.94,3.48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom1);
export default __webpack_public_path__ + "static/media/bottom1.aa0a222dd6f9db58eeb6ea5401129358.svg";
export { ForwardRef as ReactComponent };